var map = {
	"./theme1/documents/Document.vue": [
		"6a6a",
		"chunk-65303206"
	],
	"./theme2/documents/Document.vue": [
		"19f5",
		"chunk-56927b56"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4961";
module.exports = webpackAsyncContext;